import { api } from '@/constants'
import { getAuthHeader } from '@/util'
import baseURL from '@/service/api'

const auth = {
  login: payloads => {
    const url = api.auth.login
    return baseURL.post(url, payloads)
  },
  logout: () => {
    const url = api.auth.logout
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  profile: () => {
    const url = api.profile
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateProfile: payloads => {
    const url = api.profile
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  resetPassword: payloads => {
    const url = api.auth.resetPassword
    return baseURL.patch(url, payloads, { headers: getAuthHeader() })
  },
  changePassword: payloads => {
    const url = api.auth.changePassword
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  forgotPassword: payloads => {
    const url = api.auth.forgotPassword
    return baseURL.post(url, payloads)
  }
}
export default auth
